import { isBrowser as i } from "./client.js";
const v = () => i() && "IntersectionObserver" in window, c = ({
  $el: r,
  callback: n,
  options: o,
  autoUnobserve: s = !0
}) => {
  if (!v() || !r)
    return;
  const e = new IntersectionObserver((t) => {
    t[0].intersectionRatio <= 0 || (n(t, e), s && e.unobserve(r));
  }, o);
  return e.observe(r), e;
};
export {
  c as createObserver,
  v as isIntersectionObserverAvailable
};
